import createReactComponent from '../createReactComponent';
var TrendingDown = createReactComponent('TrendingDown', [['polyline', {
  points: '23 18 13.5 8.5 8.5 13.5 1 6',
  key: '1gv6g7'
}], ['polyline', {
  points: '17 18 23 18 23 12',
  key: '1v59av'
}]]);
export default TrendingDown;